const resources = {
    pageTitle: 'Sign in for a personalized experience',
    personalizedBeautyTitle: 'Tailored product recommendations',
    perksTitle: 'Beauty Insider perks & offers',
    adviceTitle: 'Guidance that improves over time',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    forgotPassword: 'Forgot password?',
    termsPrefix: 'By clicking "Sign In", you (1) agree to the current version of Sephora’s ',
    termsOfUse: 'TERMS OF USE',
    termsAnd: ', and (2) have read Sephora\'s ',
    privacyPolicy: 'Privacy Policy',
    signInButton: 'Sign In',
    continueAsGuest: 'Continue as a Guest',
    enterPasswordErrorMessage: 'Please enter your password.',
    passwordLengthInvalid: 'Please review your password. Passwords are 6 to 12 characters long.',
    emailEmpty: 'Please enter an e-mail address in the format username@domain.com.',
    emailInvalid: 'Please enter an e-mail address in the format username@domain.com.',
    unableToLogYouIn: 'Unable to log you in. Please try again.',
    genericErrorMessage: 'Login failed. Please try again.',
    checkEmailPassword: 'There is an error with your email and/or password. Please try again or click \"Forgot Password?\".',
    verificationFailedTitle: 'Verification Failed',
    verificationFailedMessage: 'We were unable to verify your session. Please log out and log in again to continue.',
    verificationFailedButton: 'OK'
};

export default function getResource(label) {
    return resources[label];
}
